const myProjects = [
  //NEXTJS
  {
    name: "WrapXen",
    techstack: ["NextJs", "FullStack", "ReactJs", "WIX", "Tailwind CSS"],
    desc: "Wrapxen is an online store specializing in premium full-body laptop skins.The store is built using Next.js, ensuring a smooth shopping experience with fast loading times and seamless navigation. Wrapxen focuses on offering an intuitive, user-friendly experience from start to finish.",
    link: "https://wrapxen-mubashir1920s-projects.vercel.app/",
    github: "https://github.com/Mubashir1920",
    image: "wrapxen.png",
    type: "Full-Stack",
  },
  {
    name: "TechNThreads -Everyday Blogs ",
    techstack: ["NextJs", "Front End", "Blogs", "Tailwind CSS"],
    desc: "TechnThreads is a vibrant blogging hub blending technical insights and everyday musings with a casual, humorous tone for curious minds.Inlcudes Authenticated Comments and Search Functionality Throughout the App",
    link: "https://technthread.vercel.app",
    github: "https://github.com/Mubashir1920",
    image: "technthread.png",
    type: "Front-End",
  },
  {
    name: "Anchors Labs LLC",
    techstack: ["Wordpress", "Elementor", "Lenis", "SliderRev"],
    desc: "AnchorsLab LLC enables global business. It handle company formation, PayPal accounts, and trademarks—fast, compliant, and hassle-free. Operate worldwide with confidence.",
    link: "https://anchorlabsllc.com/",
    github: "https://github.com/Mubashir1920",
    image: "anchorslab.png",
    type: "WORDPRESS",
  },
  {
    name: "Activemen - Premium Men Sportswear",
    techstack: ["NextJs", "Front End", "LandingPage", "Tailwind CSS"],
    desc: "Activemen is a Premium Mens Sports and Active Wear Clothes distributor based in USA Chicago. They want to boost their sales I worked closely with the client to identify key personas within the target audience and tailored the landing page sections . ",
    link: "https://activemen.vercel.app/",
    github: "https://github.com/Mubashir1920",
    image: "activemen.png",
    type: "Front-End",
  },
  {
    name: "Green Hands LandScaping",
    techstack: ["NextJs", "Front End", "LandingPage", "Tailwind CSS"],
    desc: "Green Hands Land Scaping is a Well Quoted Company in US. They Provide Multiple House and Commercial Landscaping Services.To Boost the Sales they wanted a Responsive well put together Landing Page for their Services",
    link: "https://greenhandslandscaping.vercel.app/",
    github: "https://github.com/Mubashir1920",
    image: "greenhands.png",
    type: "Front-End",
  },
  //MERN STACK
  {
    name: "Rome Wheels",
    techstack: [
      "MongoDB",
      "Express.js",
      "ReactJs",
      "Node.js",
      "JWT",
      "Tailwind CSS",
    ],
    desc: "Romewheels is an online car rental platform built with the MERN stack, utilizing MongoDB for database management, Express.js and Node.js for the backend, and React.js for a dynamic user interface. JWT is used for secure authentication, and Tailwind CSS provides a sleek, responsive design.",
    link: "https://romewheels.netlify.app",
    github: "https://github.com/Mubashir1920",
    image: "romewheels.png",
    type: "Full-Stack",
  },
  {
    name: "Echo Notes",
    techstack: ["MongoDB", "Express.js", "ReactJs", "Node.js", "Tailwind CSS"],
    desc: "Echo Notes is a MERN Stack application designed for efficiently taking and managing notes. It offers a seamless user experience, leveraging MongoDB, Express, React, and Node.js to provide a reliable and responsive platform for organizing thoughts, tasks, and important information.",
    link: "https://echonote.netlify.app/",
    github: "https://github.com/Mubashir1920",
    image: "Echonotes.png",
    type: "Full-Stack",
  },
  //NextJS
  {
    name: "Rome Rents",
    techstack: ["NextJs", "Cloudinary", "ReactJs", "FullStack", "Tailwind CSS"],
    desc: "RomeRents is a user-friendly platform built with Next.js, designed to simplify the process of listing and finding rental properties. Whether you're a landlord or a tenant, it offers an efficient and straightforward way to connect with potential renters or find your next home",
    link: "https://rome-rents.vercel.app/",
    github: "https://github.com/Mubashir1920",
    image: "RomeRents (6).jpeg",
    type: "Full-Stack",
  },
  //REACT JS
  {
    name: "Urban Edge Salon",
    techstack: ["ReactJs", "Tailwind", "Firebase", "GSAP"],
    desc: "Urban Edge Salon is built using a robust tech stack, including React.js for a dynamic user interface, GSAP for smooth, eye-catching animations, and Tailwind CSS for sleek, responsive styling. For seamless online booking, we integrated Firebase, ensuring a secure and efficient experience.",
    link: "https://urbanedge.netlify.app",
    github: "https://github.com/Mubashir1920",
    image: "UrbanEdge.png",
    type: "Front-End",
  },
  {
    name: "Flavusion",
    techstack: ["ReactJs", "Bootstrap", "Redux", "Firebase"],
    desc: "Flavusion is a recipe app built with React.js for a dynamic interface, styled with Bootstrap for a responsive design, and powered by Redux for smooth state management. Firebase handles secure authentication and data storage.",
    link: "https://flavusion.netlify.app",
    github: "https://github.com/Mubashir1920",
    image: "Flavusion.png",
    type: "Front-End",
  },
  {
    name: "FitGymLog",
    techstack: ["ReactJs", "Redux", "Bootstrap"],
    desc: "FitGymLog is a fitness tracking app developed with React.js for a dynamic interface, Redux for efficient state management, and Bootstrap for a responsive and stylish design.",
    link: "https://fitgymlog.netlify.app",
    github: "https://github.com/Mubashir1920",
    image: "Fitlog.png",
    type: "Front-End",
  },
  {
    name: "ProjectsHub",
    techstack: ["ReactJs", "API", "Axios"],
    desc: "ProjectsHub is a project management tool developed with React.js for a dynamic interface, API integration for data interaction, and Axios for efficient API requests. It provides a seamless experience for managing and tracking projects.",
    link: "https://projectshub.netlify.app",
    github: "https://github.com/Mubashir1920",
    image: "Projectshub.png",
    type: "Front-End",
  },
  // WORDPRESS
  {
    name: "Amina Art",
    techstack: ["WordPress", "E-commerce Platform"],
    desc: "aminart.shop is an online e-commerce store specializing in beaded bags in Pakistan. The website features a user-friendly interface and responsive design to showcase a wide range of beaded bags, offering a seamless shopping experience.",
    link: "https://aminart.talhajeweller.pk/",
    github: "https://github.com/Mubashir1920",
    image: "Aminart.jpeg",
    type: "WORDPRESS",
  },
  {
    name: "Bayaan Band",
    techstack: ["WordPress", "Band"],
    desc: "Bayaan  is an alternative rock band from Lahore, Pakistan. It is the winning band of Pepsi Battle of the Bands Season 3 in 2018.Bayaan[11] started its musical journey through a popular music show in Pakistan, Nescafe Basement.[12] With Nescafe Basement, Bayaan released a few singles in Pakistan.",
    link: "https://bayaanofficial.com/",
    github: "#",
    image: "bayaan.png",
    type: "WORDPRESS",
  },
  {
    name: "Opentech.pk",
    techstack: ["WordPress"],
    desc: "Opentech.pk is a professional website designed for a training institute, developed with WordPress. It features a clean, responsive design, providing information about various training programs and courses offered by the institute.",
    link: "https://opentech.pk",
    github: "https://github.com/Mubashir1920",
    image: "Opentech.jpg",
    type: "WORDPRESS",
  },
  {
    name: "Cyberwing.pk",
    techstack: ["WordPress"],
    desc: "Cyberwing.pk is a comprehensive website for a cyber training institute, built with WordPress. It offers detailed information on various IT training programs and hands-on labs, featuring a responsive design to engage and inform potential students.",
    link: "https://cyberwing.pk",
    github: "https://github.com/Mubashir1920",
    image: "Cyberwing.pk.jpg",
    type: "WORDPRESS",
  },
  {
    name: "Ecomtimes",
    techstack: ["WordPress", "E-commerce Platform"],
    desc: "Ecomtime is a versatile online e-commerce store offering a wide range of products. The website is designed to provide a smooth and intuitive shopping experience with a responsive layout, making it easy for customers to browse and purchase items.",
    link: "#",
    github: "https://github.com/Mubashir1920",
    image: "ecomtimes.jpg",
    type: "WORDPRESS",
  },

  {
    name: "Ivor Media",
    techstack: ["WordPress"],
    desc: "Ivor Media is a website developed with WordPress, specializing in online digital products. It features a modern design and responsive layout, providing an easy-to-navigate platform for purchasing and exploring various digital products.",
    link: "#",
    github: "https://github.com/Mubashir1920",
    image: "IvorMedia.jpg",
    type: "WORDPRESS",
  },

  //HTML  /CSS  /JAVASCRIPT
  {
    name: "Fox App Landing Page",
    techstack: ["HTML", "CSS", "Vanilla JS"],
    desc: "The Fox App Landing Page is crafted using HTML for the structure, CSS for styling, and Vanilla JS for interactive elements. This landing page offers a clean and responsive design, providing an engaging user experience.",
    link: "https://github.com/Mubashir1920",
    github: "https://github.com/Mubashir1920",
    image: "foxapp-min.webp",
    type: "Front-End",
  },
  {
    name: "AMN EATS",
    techstack: ["HTML", "CSS"],
    desc: "AMN EATS is a Online Food Shop built with HTML for the layout and CSS for styling, offering a simple and responsive design that ensures a smooth user experience.",
    link: "https://github.com/Mubashir1920",
    github: "https://github.com/Mubashir1920",
    image: "amneats-min.webp",
    type: "Front-End",
  },

  {
    name: "Tracalorie",
    techstack: ["HTML", "CSS", "Vanilla JS"],
    desc: "Tracalorie is a calorie tracking application built using HTML for structure, CSS for styling, and Vanilla JS for functionality. It offers a simple and responsive design, allowing users to easily manage their daily calorie intake.",
    link: "https://tracalorie.netlify.app",
    github: "https://github.com/Mubashir1920",
    image: "tracalorie-min.webp",
    type: "Front-End",
  },
  {
    name: "DrTank Landing Page",
    techstack: ["HTML", "CSS", "JavaScript"],
    desc: "DrTank Landing Page is a visually engaging landing page for a bar, developed with HTML for structure, CSS for styling, and JavaScript for interactive elements. It features a clean and responsive design that captures the bar's ambiance and services.",
    link: "#",
    github: "https://github.com/Mubashir1920",
    image: "drtank-min.webp",
    type: "Front-End",
  },
  {
    name: "Todolist App",
    techstack: ["HTML", "CSS", "JavaScript"],
    desc: "The Todolist App is a task management tool built with HTML for structure, CSS for styling, and JavaScript for interactivity. It features a clean and user-friendly design, allowing users to efficiently organize and track their daily tasks.",
    link: "https://taskend.netlify.app/",
    github: "https://github.com/Mubashir1920",
    image: "todolist-min.webp",
    type: "Front-End",
  },
];
export default myProjects;
